import { getReduxStore } from "@/store";
import { Actions } from "@/store/user/slice";
import { Selectors } from "@/store/user/selectors";
import { tMaster } from "@/types";
import { TaskEditorCacheService } from "../taskEditor/cache";

export const MasterMutationHandler = {
  masterUpdated({
    master_id,
    updates,
  }: {
    master_id?: string;
    updates: Partial<tMaster>;
  }) {
    const reduxStore = getReduxStore()!;
    const authMasterId = Selectors.getMasterId(reduxStore.getState());
    if (master_id && authMasterId !== master_id) {
      return;
    }
    reduxStore.dispatch(Actions.updateMaster(updates));
    TaskEditorCacheService.updateMaster({
      masterId: master_id,
      updates,
    });
  },
};
